import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTataComponent } from './simple-icons-tata.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTataComponent ],
    exports:      [ SimpleIconsTataComponent ],
    bootstrap:    []
})
export class SimpleIconsTataModule {}
